var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('league-price-form',{attrs:{"league-id":_vm.league.id,"league-trial":_vm.league.trial,"price":_vm.league.league_price,"read-only":false,"button-text":"Submit","balance":_vm.balance},on:{"price-set":_vm.refreshPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }